import React from 'react';
import Card from '../Card';
import UserPlayer from '../../entities/players/UserPlayer';
import Constants from '../../constants/Constants';

export default class StopCard extends Card {

    onAfterCardThrownFromPlayerToUsedPile = async () => {
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_STOP_CARD);

        let nextPlayerEntity = this.gameCtx.gameSeqHandler.getNextTurnEntity();

        if (nextPlayerEntity instanceof UserPlayer) {

            nextPlayerEntity.subscribePlayMethod(
                this.userPlayerTurnSkipped,
                Constants.FLAGS_SINGLE_TIME_USE,
                Constants.FLAGS_REPLACE_METHOD
            );
        }
        else {

            nextPlayerEntity.subscribePlayMethod(
                this.computerPlayerTurnSkipped,
                Constants.FLAGS_SINGLE_TIME_USE,
                Constants.FLAGS_REPLACE_METHOD
            );
        }
    }

    // COMPUTER PLAYER MOVES

    computerPlayerTurnSkipped = async () => {
        await this.gameCtx.waitFor(Constants.INTERVAL_FOR_COMPUTER_PLAYER_STOP_CARD);
    }

    // USER PLAYER MOVES

    userPlayerTurnSkipped = async () => {
        let text = <div className="popup-text interval-popup-text increasd-text">דילגו על תורך<br />"באמצעות קלף "ארוחה קפואה!</div>

        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
        cEntity.addPopupWithInterval(text);
        await this.gameCtx.waitFor(Constants.INTERVAL_BEFORE_REMOVE_POPUP);

        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_CARD_POPUP);

        cEntity.resolvePlayerFinal(0);
    }
}
